import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalExpensesTugoStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'This section relates to medical expenses such as doctor visits, prescriptions, hospitalisation as well as expenses related to maternity, cleft lip, and oncology.',
  },
  outpatientDoctorOrClinicVisit: {
    id: 'fastCover.medicalExpensesTugoStep.outpatientDoctorOrClinicVisit',
    defaultMessage: 'Outpatient Doctor or Clinic Visit',
  },
  inPatientHospitalExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.inPatientHospitalExpenses',
    defaultMessage: 'In Patient Hospital Expenses',
  },
  bloodPlasmaOrWholeBloodTransfusion: {
    id: 'fastCover.medicalExpensesTugoStep.bloodPlasmaOrWholeBloodTransfusion',
    defaultMessage: 'Blood plasma or whole blood (transfusion)',
  },
  anaesthesiology: {
    id: 'fastCover.medicalExpensesTugoStep.anaesthesiology', 
    defaultMessage: 'Anaesthesiology',
  },
  dentalSurgery: {
    id: 'fastCover.medicalExpensesTugoStep.dentalSurgery',
    defaultMessage: 'Dental Surgery',
  },
  wellBabyCare: {
    id: 'fastCover.medicalExpensesTugoStep.wellBabyCare',
    defaultMessage: 'Well Baby Care',
  },
  annualHealthExam: {
    id: 'fastCover.medicalExpensesTugoStep.annualHealthExam',
    defaultMessage: 'Annual Health Exam',
  },
  vaccinationExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.vaccinationExpenses',
    defaultMessage: 'Vaccination Expenses',
  },
  cleftLipAndPalateAssistance: {
    id: 'fastCover.medicalExpensesTugoStep.cleftLipAndPalateAssistance',
    defaultMessage: 'Cleft Lip and Palate Assistance',
  },
  maternityExpense: {
    id: 'fastCover.medicalExpensesTugoStep.maternityExpense',
    defaultMessage: 'Maternity Expense',
  },
  oncology: {
    id: 'fastCover.medicalExpensesTugoStep.oncology',
    defaultMessage: 'Oncology',
  },
  diagnosticImaging: {
    id: 'fastCover.medicalExpensesTugoStep.diagnosticImaging',
    defaultMessage: 'Diagnostic imaging',
  },
  diagnosticNonMRI: {
    id: 'fastCover.medicalExpensesTugoStep.diagnosticNonMRI',
    defaultMessage: 'Non-MRI',
  },
  hospitalizationWarning: {
    id: 'fastCover.medicalExpensesTugoStep.hospitalizationWarning',
    defaultMessage: 'Expenses for scheduled confinement in hospital or scheduled surgery, including outpatient surgery, must be submitted to the Company for approval three days in advance of the date of admission. Failure to submit such notification within the prescribed period of time will limit coverage to 70% of all expenses incurred, to an overall maximum of $10,000.',
  },
  isYourClaimRelatedToPsychiatricTreatment: {
    id: 'fastCover.medicalExpensesTugoStep.claimRelatedToPsychiatricTreatment',
    defaultMessage: 'Is your claim related to Psychiatric Treatment?',
  },
  isYourClaimRelatedToHIV: {
    id: 'fastCover.medicalExpensesTugoStep.isYourClaimRelatedToHIV',
    defaultMessage: 'Is your claim related to HIV?',
  },
  diagnosticMRI: {
    id: 'fastCover.medicalExpensesTugoStep.diagnosticMRI',
    defaultMessage: 'MRI',
  },
  isClaimRelatedToSelfInflicted: {
    id: 'fastCover.medicalExpensesTugoStep.isClaimRelatedToSelfInflicted',
    defaultMessage: 'Is your claim related to a self-inflicted injury or suicide attempt?',
  },
    yes: {
    id: 'fastCover.medicalExpensesTugoStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.medicalExpensesTugoStep.no',
    defaultMessage: 'No',
  },
  selfInflictedInjuriesAndAttemptedSuicide: {
    id: 'fastCover.medicalExpensesTugoStep.selfInflictedInjuriesAndAttemptedSuicide',
    defaultMessage: 'Self Inflicted Injuries and Attempted Suicide',
  },
  standardXRayAndLaboratoryExaminations: {
    id: 'fastCover.medicalExpensesTugoStep.standardXRayAndLaboratoryExaminations',
    defaultMessage: 'Standard X-Ray and Laboratory Examinations',
  },
  mriScans: {
    id: 'fastCover.medicalExpensesTugoStep.mriScans',
    defaultMessage: 'MRI Scans',
  },
  maternityExpenseDescription: {
    id: 'fastCover.medicalExpensesTugoStep.maternityExpenseDescription',
    defaultMessage: 'This section relates to expenses actually incurred for pregnancy, childbirth, miscarriage, complications and maternity, including pre-post natal costs.',
  },
  maternityExpenseBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.maternityExpenseBenefit',
    defaultMessage: 'Maternity Expense Benefit',
  },
  maternityExpenseToolTip:{
    id: 'fastCover.medicalExpensesTugoStep.maternityExpenseToolTip',
    defaultMessage: 'In the event of pregnancy or childbirth, the Company will reimburse eligible expenses provided that family coverage had been in force with respect to the claimant for the entire term of the pregnancy, or when the insured’s coverage is in effect as of the inception date of the policy, subject to a lifetime maximum of $25,000.00.',
  },
  oncologyDescription: {
    id: 'fastCover.medicalExpensesTugoStep.oncologyDescription',
    defaultMessage: 'This section relates to expenses actually incurred for in and out patient oncology treatments.',
  },
  oncologyExpenseBenefits: {
    id: 'fastCover.medicalExpensesTugoStep.oncologyExpenseBenefits',
    defaultMessage: 'Oncology Expense Benefits',
  },
  oncologyExpenseBenefitsTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.oncologyExpenseBenefitsTooltip',
    defaultMessage: 'Charges for eligible oncology treatments as an in-patient or out-patient are covered up to a lifetime maximum of $50,000.00.',
  },
  emergencyMedicalEvacuation: {
    id: 'fastCover.medicalExpensesTugoStep.emergencyMedicalEvacuation',
    defaultMessage: 'Emergency Medical Evacuation',
  },
  emergencyMedicalEvacuationDescription: {
    id: 'fastCover.medicalExpensesTugoStep.emergencyMedicalEvacuationDescription',
    defaultMessage: 'This section relates to expenses for emergency medical evacuation when immediate medical attention is required.',
  },
  emergencyMedicalEvacuationBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.emergencyMedicalEvacuationBenefit',
    defaultMessage: 'Emergency Medical Evacuation Benefit',
  },
  emergencyMedicalEvacuationTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.emergencyMedicalEvacuationTooltip',
    defaultMessage: 'Coverage for emergency medical evacuation to the nearest appropriate medical facility or repatriation to your home country.',
  },
  repatriationOfMortalRemains: {
    id: 'fastCover.medicalExpensesTugoStep.repatriationOfMortalRemains',
    defaultMessage: 'Repatriation of Mortal Remains',
  },
  repatriationOfMortalRemainsDescription: {
    id: 'fastCover.medicalExpensesTugoStep.repatriationOfMortalRemainsDescription',
    defaultMessage: 'This section relates to expenses for repatriation of mortal remains in case of death.',
  },
  repatriationOfMortalRemainsBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.repatriationOfMortalRemainsBenefit',
    defaultMessage: 'Repatriation of Mortal Remains Benefit',
  },
  repatriationOfMortalRemainsTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.repatriationOfMortalRemainsTooltip',
    defaultMessage: 'Coverage for the cost of repatriating mortal remains to your home country.',
  },
  mentalHealthServices: {
    id: 'fastCover.medicalExpensesTugoStep.mentalHealthServices',
    defaultMessage: 'Mental Health Services',
  },
  mentalHealthServicesDescription: {
    id: 'fastCover.medicalExpensesTugoStep.mentalHealthServicesDescription',
    defaultMessage: 'This section relates to expenses for mental health services and psychological treatment.',
  },
  mentalHealthServicesBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.mentalHealthServicesBenefit',
    defaultMessage: 'Mental Health Services Benefit',
  },
  mentalHealthServicesTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.mentalHealthServicesTooltip',
    defaultMessage: 'Coverage for mental health services including counseling, therapy, and psychological treatment.',
  },
  physicalTherapyRehabilitation: {
    id: 'fastCover.medicalExpensesTugoStep.physicalTherapyRehabilitation',
    defaultMessage: 'Physical Therapy & Rehabilitation',
  },
  physicalTherapyRehabilitationDescription: {
    id: 'fastCover.medicalExpensesTugoStep.physicalTherapyRehabilitationDescription',
    defaultMessage: 'This section relates to expenses for physical therapy and rehabilitation services.',
  },
  physicalTherapyRehabilitationBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.physicalTherapyRehabilitationBenefit',
    defaultMessage: 'Physical Therapy & Rehabilitation Benefit',
  },
  physicalTherapyRehabilitationTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.physicalTherapyRehabilitationTooltip',
    defaultMessage: 'Coverage for physical therapy, occupational therapy, and rehabilitation services.',
  },
  prescriptionMedications: {
    id: 'fastCover.medicalExpensesTugoStep.prescriptionMedications',
    defaultMessage: 'Prescription Medications',
  },
  prescriptionMedicationsDescription: {
    id: 'fastCover.medicalExpensesTugoStep.prescriptionMedicationsDescription',
    defaultMessage: 'This section relates to expenses for prescription medications and pharmaceutical treatments.',
  },
  prescriptionMedicationsBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.prescriptionMedicationsBenefit',
    defaultMessage: 'Prescription Medications Benefit',
  },
  prescriptionMedicationsTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.prescriptionMedicationsTooltip',
    defaultMessage: 'Coverage for prescription medications prescribed by a licensed physician.',
  },
  cleftLipAndPalateAssistanceDescription: {
    id: 'fastCover.medicalExpensesTugoStep.cleftLipAndPalateAssistanceDescription',
    defaultMessage: 'This section relates to expenses actually incurred for specialized dental treatment for covered dependent children with cleft lip and palate.',
  },
  cleftLipAndPalateTreatment: {
    id: 'fastCover.medicalExpensesTugoStep.cleftLipAndPalateTreatment',
    defaultMessage: 'Cleft Lip and Palate Treatment',
  },
  cleftLipAndPalateTreatmentTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.cleftLipAndPalateTreatmentTooltip',
    defaultMessage: 'Expenses for scheduled confinement in hospital or scheduled surgery, including outpatient surgery, must be submitted to the Company for approval three days in advance of the date of admission.',
  },
  babysDateOfBirth: {
    id: 'fastCover.medicalExpensesTugoStep.babysDateOfBirth',
    defaultMessage: "Baby's Date of Birth",
  },
  didYouContactUsPriorToYourHospitalization: {
    id: 'fastCover.medicalExpensesTugoStep.didYouContactUsPriorToYourHospitalization',
    defaultMessage: 'Did you contact us prior to your hospitalization?',
  },
  hospitalChargesRelatedToPsychiatricTreatment: {
    id: 'fastCover.medicalExpensesTugoStep.hospitalChargesRelatedToPsychiatricTreatment',
    defaultMessage: 'Hospital Charges Related to Psychiatric Treatment',
  },
  hospitalChargesRelatedToHIV: {
    id: 'fastCover.medicalExpensesTugoStep.hospitalChargesRelatedToHIV',
    defaultMessage: 'Hospital Charges Related to HIV',
    },
    hospitalizationCharges: {
      id: 'fastCover.medicalExpensesTugoStep.hospitalizationCharges',
      defaultMessage: 'Hospitalization Charges',
    },

  

  whatAreYourExpensesRelatedTo: {
    id: 'fastCover.medicalExpensesTugoStep.whatAreYourExpensesRelatedTo',
    defaultMessage: 'What are your expenses related to?',
  },
  otherExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.otherExpenses',
    defaultMessage: 'Other Expenses',
  },
  medicalHospitalExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.medicalHospitalExpenses',
    defaultMessage: 'Medical & Hospital Expenses',
  },
  wereYouHospitalisedForMoreThanThreeDays: {
    id: 'fastCover.medicalExpensesTugoStep.wereYouHospitalisedForMoreThanThreeDays',
    defaultMessage: 'Were you hospitalised for more than 3 days?',
  },
  wereYouHospitalisedForMoreThanTenDays: {
    id: 'fastCover.medicalExpensesTugoStep.wereYouHospitalisedForMoreThanTenDays',
    defaultMessage: 'Were you hospitalised for more than 10 days?',
  },
  periodOfHospitalisation: {
    id: 'fastCover.medicalExpensesTugoStep.periodOfHospitalisation',
    defaultMessage: 'Period of hospitalisation',
  },
  admissionDate: {
    id: 'fastCover.medicalExpensesTugoStep.admissionDate',
    defaultMessage: 'Admission Date',
  },
  dischargeDate: {
    id: 'fastCover.medicalExpensesTugoStep.dischargeDate',
    defaultMessage: 'Discharge Date',
  },
  didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: {
    id: 'fastCover.medicalExpensesTugoStep.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised',
    defaultMessage: 'Did an accompanying person travel from your home country whilst you were hospitalised?',
  },
  cashAllowanceWhileInHospital: {
    id: 'fastCover.medicalExpensesTugoStep.cashAllowanceWhileInHospital',
    defaultMessage: 'Cash allowance while in hospital',
  },
  accompanyingPersonExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.accompanyingPersonExpenses',
    defaultMessage: 'Accompanying person expenses',
  },
  expenseFor: {
    id: 'fastCover.medicalExpensesTugoStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.medicalExpensesTugoStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  descriptionOfExpense: {
    id: 'fastCover.medicalExpensesTugoStep.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.medicalExpensesTugoStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.medicalExpensesTugoStep.currency',
    defaultMessage: 'Currency',
  },

  dentalExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.dentalExpenses',
    defaultMessage: 'Dental Expenses',
  },
  funeralExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.funeralExpenses',
    defaultMessage: 'Funeral Expenses',
  },
  expensesArisingFromTerrorism: {
    id: 'fastCover.medicalExpensesTugoStep.expensesArisingFromTerrorism',
    defaultMessage: 'Expenses arising from terrorism',
  },
  isRequired: {
    id: 'fastCover.medicalExpensesTugoStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.medicalExpensesTugoStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.medicalExpensesTugoStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  opticalTreatment: {
    id: 'fastCover.medicalExpensesTugoStep.opticalTreatment',
    defaultMessage: 'Optical treatment',
  },
  ancillaryServices: {
    id: 'fastCover.medicalExpensesTugoStep.ancillaryServices',
    defaultMessage: 'Ancillary services',
  },
  ancillaryServicestTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.ancillaryServicestTooltip',
    defaultMessage: 'Services provided by registered: acupuncturists, chiropractors, dieticians, osteopaths, physiotherapists, podiatrists, or Chinese medicine practitioners.',
  },
  mentalHealth: {
    id: 'fastCover.medicalExpensesTugoStep.mentalHealth',
    defaultMessage: 'Mental Health',
  },
  sexualHealth: {
    id: 'fastCover.medicalExpensesTugoStep.sexualHealth',
    defaultMessage: 'Sexual Health',
  },
  extraTravelAndAccommodation: {
    id: 'fastCover.medicalExpensesTugoStep.extraTravelAndAccommodation',
    defaultMessage: 'Extra travel and accommodation',
  },
  searchAndRescue: {
    id: 'fastCover.medicalExpensesTugoStep.searchAndRescue',
    defaultMessage: 'Search and rescue',
  },
  urgentCareOutOfHoursvisits: {
    id: 'fastCover.medicalExpensesTugoStep.urgentCareOutOfHoursvisits',
    defaultMessage: 'Urgent care / out of hours visits',
  },
  prescriptions: {
    id: 'fastCover.medicalExpensesTugoStep.prescriptions',
    defaultMessage: 'Prescriptions',
  },
  GPVisits: {
    id: 'fastCover.medicalExpensesTugoStep.GPVisits',
    defaultMessage: 'GP visits',
  },
  otherMedicalExpenses: {
    id: 'fastCover.medicalExpensesTugoStep.otherMedicalExpenses',
    defaultMessage: 'Other medical expenses',
  },
  rehabilitationAndOccupationalTherapy: {
    id: 'fastCover.medicalExpensesTugoStep.rehabilitationAndOccupationalTherapy',
    defaultMessage: 'Rehabilitation and occupational therapy',
  },
  rehabilitationAndOccupationalTherapyTooltip: {
    id: 'fastCover.medicalExpensesTugoStep.rehabilitationAndOccupationalTherapyTooltip',
    defaultMessage: 'Any registered service provided as treatment or advice related to illness or injury to promote your physical wellbeing and individual dependence.',
  },
  maternityCare: {
    id: 'fastCover.medicalExpensesTugoStep.maternityCare',
    defaultMessage: 'Maternity care',
  },
  replacementStaff: {
    id: 'fastCover.medicalExpensesTugoStep.replacementStaff',
    defaultMessage: 'Replacement staff',
  },
  repatriationBenefit: {
    id: 'fastCover.medicalExpensesTugoStep.repatriationBenefit',
    defaultMessage: 'Repatriation benefit',
  },

  wasTheDeathCausedByAnInjury: {
    id: 'fastCover.medicalExpensesTugoStep.wasTheDeathCausedByAnInjury',
    defaultMessage: 'Was the death caused by an injury?',
  },
  lossOfLife: {
    id: 'fastCover.medicalExpensesTugoStep.lossOfLife',
    defaultMessage: 'Loss of Life',
  },
  selectInsuredForExpense: {
    id: 'fastCover.medicalExpensesTugoStep.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.MedicalExpenses/messages.js